/**
 * Resolução determinística de conflitos de leader (epoch > fencing > tabId).
 */

export interface LeaderClaim {
  tabId: string;
  epoch: number;
  fencingToken: number;
}

export function resolveLeaderConflict(
  local: LeaderClaim,
  remote: LeaderClaim
): 'local' | 'remote' {
  if (remote.epoch !== local.epoch) {
    return remote.epoch > local.epoch ? 'remote' : 'local';
  }
  if (remote.fencingToken !== local.fencingToken) {
    return remote.fencingToken > local.fencingToken ? 'remote' : 'local';
  }
  return remote.tabId > local.tabId ? 'remote' : 'local';
}
